import { render } from "./Distributor.vue?vue&type=template&id=d4433d38&scoped=true"
import script from "./Distributor.vue?vue&type=script&lang=js"
export * from "./Distributor.vue?vue&type=script&lang=js"

import "./Distributor.vue?vue&type=style&index=0&id=d4433d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4433d38"]])

export default __exports__